if (!customElements.get('sticky-anchor-nav')) {
  customElements.define('sticky-anchor-nav', class StickyAnchorNav extends HTMLElement {
    constructor() {
      super();
      this.header = document.querySelector('.header-section') || document.querySelector('theme-header') || document.querySelector('header');
      this.links = this.querySelectorAll('.sticky-anchor-nav__item');
      
      this.initStickyOffset();
      this.initSmoothScroll();
      this.initIntersectionObserver();

      window.addEventListener('resize', this.initStickyOffset.bind(this));
    }

    initStickyOffset() {
      if (this.header) {
        const headerHeight = this.header.getBoundingClientRect().height;
        this.style.setProperty('--header-height', `${headerHeight}px`);
        
        const section = this.closest('.shopify-section');
        if (section) {
          section.style.position = 'sticky';
          section.style.top = `${headerHeight}px`;
          section.style.zIndex = '10';
        }
      }
    }

    initSmoothScroll() {
      this.links.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const targetSelector = link.getAttribute('data-target');
          if (!targetSelector) return;
          
          // Try to select the target element
          let targetElement = null;
          try {
            targetElement = document.querySelector(targetSelector);
          } catch (err) {
            console.warn(`[sticky-anchor-nav] Invalid selector: ${targetSelector}`);
            return;
          }

          if (targetElement) {
            const headerHeight = this.header ? this.header.getBoundingClientRect().height : 0;
            const navHeight = this.getBoundingClientRect().height;
            
            // Calculate absolute position to scroll to
            const elementPosition = targetElement.getBoundingClientRect().top;
            // Subtracting 20px extra buffer
            const offsetPosition = elementPosition + window.pageYOffset - headerHeight - navHeight - 20;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
            
            // Set active state immediately on click
            this.setActiveItem(targetSelector);
          }
        });
      });
    }

    setActiveItem(activeId) {
      this.links.forEach(link => {
        if (link.getAttribute('data-target') === activeId) {
          link.classList.add('is-active');
        } else {
          link.classList.remove('is-active');
        }
      });
    }

    initIntersectionObserver() {
      this.scrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.scrollHandler, { passive: true });
      // Call once initially
      this.onScroll();
    }

    onScroll() {
      const headerHeight = this.header ? this.header.getBoundingClientRect().height : 0;
      const navHeight = this.getBoundingClientRect().height;
      // 100px buffer to trigger active state slightly before the top
      const offset = headerHeight + navHeight + 100; 

      let currentActiveId = null;

      // Iterate through links and check their target's position
      this.links.forEach(link => {
        const targetSelector = link.getAttribute('data-target');
        if (!targetSelector) return;
        
        try {
          const targetElement = document.querySelector(targetSelector);
          if (targetElement) {
            const rect = targetElement.getBoundingClientRect();
            // If the element's top is past our offset threshold, mark it active.
            // By going through all, the last one matching will be the lowest one on screen,
            // which usually represents the current section we are in.
            if (rect.top <= offset) {
              currentActiveId = targetSelector;
            }
          }
        } catch (err) {
          // Ignore invalid selectors
        }
      });

      // If we found an active section, update it
      if (currentActiveId) {
        this.setActiveItem(currentActiveId);
      } else if (this.links.length > 0 && window.pageYOffset === 0) {
        // If we are at the very top, activate the first item
        this.setActiveItem(this.links[0].getAttribute('data-target'));
      }
    }

    disconnectedCallback() {
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
      }
      window.removeEventListener('resize', this.initStickyOffset.bind(this));
    }
  });
}
